import { Component, OnInit, Inject } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/shared/language.service';
import { AuthService } from 'app/auth/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface DialogData {
  visitid: number;
  categoryid: number;
  //name: string;
}

@Component({
  selector: 'app-changecategories',
  templateUrl: './changecategories.component.html',
  styleUrls: ['./changecategories.component.scss']
})
export class ChangecategoriesComponent implements OnInit {
  destroychangecat$: Subject<boolean> = new Subject<boolean>();
  selected_catid:any;
  
  constructor(private dashboardService: DashboardService,
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    private dialogRef: MatDialogRef<ChangecategoriesComponent>,
    private translate: TranslateService,
    private langservice: LanguageService,
    private authService: AuthService,
  ) {
    translate.addLangs(['en', 'fr', 'hi']);
    if (this.langservice.setlang) {
      translate.setDefaultLang(this.langservice.setlang);
    }
    else {
      translate.setDefaultLang('en');
    }
    this.selected_catid = this.data.categoryid;
  }

  ngOnInit() {
    
  }
  ngOnDestroy() {
    this.destroychangecat$.next(true);
    this.destroychangecat$.unsubscribe();
    this.selected_catid =null;
  }
  updatecategory() {
   
    this.dashboardService.update_category(this.selected_catid, this.data.visitid).pipe(takeUntil(this.destroychangecat$)).subscribe(
      data => this.successcategory(data), err => this.failedcategory(err)
    )

  }
  successcategory(data) {
    this.dashboardService.openSnackBar(this.authService.validationMsg['dashboardValidMsg.msg2'], this.authService.validationMsg['Ok']);
    this.dashboardService.categoryupdated = true;
    this.closedialog();
  }
  failedcategory(err) {
    this.dashboardService.categoryupdated = false;
    this.closedialog();
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar(this.authService.validationMsg['dashboardValidMsg.msg3'], this.authService.validationMsg['Ok']);
    }
  }
  closedialog() {

    this.dialogRef.close();
  }
}
